import { AuthenticationError } from '~/errors/AuthenticationError';
import { useAuthentication } from '~/hooks/useAuthentication';
import { User } from '~/apis/ssf';

export interface WithPrivateRouteProps {
  user: User;
}

export function withPrivateRoute<T extends WithPrivateRouteProps = WithPrivateRouteProps>(
  WrappedComponent: React.ComponentType<T>
) {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithPrivateRoute = (props: Omit<T, keyof WithPrivateRouteProps>) => {
    const { isAuthenticated, user } = useAuthentication();

    if (!isAuthenticated) {
      throw new AuthenticationError();
    }

    return <WrappedComponent {...(props as T)} user={user} />;
  };

  ComponentWithPrivateRoute.displayName = `withPrivateRoute(${displayName})`;

  return ComponentWithPrivateRoute;
}
